<template>
  <div>
    <v-row>
      <v-col cols="12">
        <user-filter ref="filter" />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="6">
        <v-btn @click="updateData" :disabled="loading">Get Data</v-btn>
      </v-col>
      <v-col cols="6">
        <vue-json-to-csv :json-data="userList" csv-title="Data Export">
          <v-btn class="mr-5">
            Download CSV
          </v-btn>
        </vue-json-to-csv>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-progress-linear v-if="loading" :indeterminate="true" />
        <v-data-table v-else :headers="table.headers" :items="userList" />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import UserFilter from "@/components/shared/user/UserFilter";
import { USER_EXPORT_QUERY } from "@/graphql/queries/reporting";
import VueJsonToCsv from "vue-json-to-csv";

export default {
  name: "UserExport",
  components: { UserFilter, VueJsonToCsv },
  data() {
    return {
      loading: false,
      userList: [],
      table: {
        headers: [
          { text: "First Name", sortable: true, value: "first_name" },
          { text: "Surname", sortable: true, value: "last_name" },
          { text: "Phone Number", sortable: true, value: "phone_number" },
          { text: "Product", sortable: true, value: "product" },
          { text: "Email", sortable: true, value: "email" },
          { text: "Reward Balance", sortable: true, value: "reward_balance" },
          { text: "Coach Name", sortable: true, value: "coach_name" },
          { text: "Bulk Messages Received (last 7 days)", value: "num_bulk_messages" },
          { text: "Last Subscription End Date", value: "last_subscription_end_date" },
        ],
      },
    };
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      console.log("vm.$store.getters.user.isSuperuser ", vm.$store.getters.user.isSuperuser);
      if (!vm.$store.getters.user.isSuperuser) {
        vm.$router.push("/reporting/company");
      }
    });
  },
  methods: {
    async updateData() {
      this.loading = true;
      const result = await this.$apollo.query({
        query: USER_EXPORT_QUERY,
        variables: {
          filters: this.$refs.filter.filters,
        },
        fetchPolicy: "no-cache",
      });

      this.userList = result.data.userExport.map((element) => {
        let coach = element.userProfile?.coach;
        let coachName = coach ? coach.firstName + " " + coach.lastName : "";
        return {
          id: element.id,
          first_name: element.firstName,
          last_name: element.lastName,
          phone_number: element.userProfile.phone,
          product: element.userProfile?.activeSubscription?.product?.type,
          email: element.email,
          reward_balance: element.userProfile.rewardBalance,
          coach_name: coachName,
          num_bulk_messages: element.userProfile.numBulkMessagesInLast7Days,
          last_subscription_end_date: element.userProfile.lastSubscriptionEndDate,
        };
      });
      this.loading = false;
    },
  },
};
</script>
